import { Edit, Error } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import { GenButton } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';

const VehicleNotFound = ({ onAddDetailsClick }) => {
  const { t } = useTranslation('orders');
  return (
    <Box>
      <Grid container direction={'column'} alignItems="center">
        <Grid item pb={2}>
          <Error color="error" sx={{ fontSize: '66px' }} />
        </Grid>
        <Grid item pb={1}>
          <Typography variant="subtitle1" textAlign={'center'}>
            {t('newOrder.vehicleNotFoundTitle')}
          </Typography>
        </Grid>
        <Grid item pb={2}>
          <Typography variant="body2" textAlign={'center'}>
            {t('newOrder.vehicleNotFoundSubTitle')}
          </Typography>
        </Grid>
        <Grid item>
          <GenButton
            startIcon={<Edit />}
            onClick={onAddDetailsClick}
            sx={{
              borderColor: theme => theme.palette.divider,
              color: theme => theme.palette.text.secondary,
            }}
            text={t('newOrder.manuallyAddDetails')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VehicleNotFound;
